module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-092.92d06af4.jpg";